import {addClass, findAll, getDataAttributes, hasClass, removeClass} from "../../../../../modules/vegas/js/util";

const VGMapRoute = {
	run(map, params, self) {
		self.PlaceMark.set(map, params);

		if (params.permission.isEvent) {
			if (params.event.includes('route')) {
				[...findAll('[data-vg-map-action="route"]')].forEach(function (element) {
					element.addEventListener('click', function (event) {
						event.preventDefault();

						let options = getDataAttributes(element, true);
						if ('params' in options) options = JSON.parse(options.params);

						let multiRoute = new ymaps.multiRouter.MultiRoute({
							referencePoints: [
								options.from,
								options.to
							],
							params: {
								avoidTrafficJams: false,
								routingMode: options.mode
							}
						}, {
							boundsAutoApply: true
						});

						map.geoObjects.removeAll();

						if (hasClass(element, 'active')) {
							removeClass(element, 'active');
							map.setCenter(options.to);
							self.PlaceMark.set(map, params);
						} else {
							addClass(element, 'active');
							map.geoObjects.add(multiRoute);
						}
					});
				});
			}
		}
	}
}

export default VGMapRoute;
